export const RESTRICTED_EN_VALUES = [
    "Amici della Luiss Association",
    "Luiss Alumni Association",
    "Quality assurance",
    "University students orientation",
    "Free mover",
    "Credits for summer abroad program courses proposed by students",
    "Advance Amerigo",
    "Caratteristiche della formazione",
    "Programma dei seminari",
    "Lista delle organizzazioni ospitanti",
    "Ricerca alloggio",
    "Tutoring and Academic Gym",
    "Digital Skills",
    "Healt care",
    "Orientamento"
];
export const RESTRICTED_IT_VALUES = [
    "Prospective students",
    "Visiting students"
];
